<style>
.page-item{
        cursor:pointer;
}
</style>

<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3 class="card-title">Detail Barang Masuk
                / ID Barang Masuk = {{ $route.query['barang_masuk_id'] }}</h3>
            </div>  
        </div>
        <div class="row">
            <div class="col-12" style="padding-bottom:10px;">
                <router-link
				  :to="{
					path: '/barang_masuk',
					query: { tahun: tahunBarangMasuk }
				  }"
				>
					<i class="fa fa-arrow-left">&nbsp;Kembali</i>
				</router-link>
                    
                    &nbsp;
                  <!--<button v-if="get_selisih >= 0 && tingkat != '2'" type="button" class="btn btn-sm btn-primary" @click="newModal">-->
				  <!-- <button v-if="get_selisih >= 0" type="button" class="btn btn-sm btn-primary" @click="newModal"> -->
				  <button v-if="canEdit" type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Tambah Detail Barang Masuk
                  </button>
            </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Data
                <div class="card-tools">
                    <input type="text" v-model="searchTerm"  placeholder="Cari">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <!-- <th>ID</th> -->
                      <th role='button' v-on:click="sortRecords('Nama', 'kategori_barang')">Rekening</th>
                      <th role='button' v-on:click="sortRecords('nama_barang', 'barang')">Nama Barang</th>
					  <th role='button' v-on:click="sortRecords('keterangan', 'barang')">Keterangan</th>
                      <th role='button' v-on:click="sortRecords('nama', 'satuan')">Satuan</th>
                      <th role='button' v-on:click="sortRecords('qty', 'detail_barang_masuk')">Qty</th>
                      <th role='button' v-on:click="sortRecords('harga', 'detail_barang_masuk')">Harga Satuan</th>
                      <th role='button' v-on:click="sortRecords('total', 'total')">Total Harga</th>
                      <!--<th v-if="get_selisih >= 0 && tingkat != '2'">Aksi</th>-->
                      <th v-if="canEdit">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="detailbarangmasuk in detailbarangmasuks.data" :key="detailbarangmasuk.id">
                        
                      <!-- <td>{{ruang.id}}</td> -->
                      <td>{{detailbarangmasuk.kategori}}</td>
                      <td class="text-capitalize">{{detailbarangmasuk.nama_barang}}</td>
					  <td>{{detailbarangmasuk.keterangan}}</td>
                      <td>{{detailbarangmasuk.nama_satuan}}</td>
                      <td>{{detailbarangmasuk.qty}}</td>
                      <td align="right">{{returnRupiahAsli(detailbarangmasuk.harga)}}</td>
                      <td align="right">{{returnRupiahBulat(detailbarangmasuk.total)}}</td>
                       <!--<td v-if="get_selisih >= 0 && tingkat != '2'">-->
                       <td v-if="canEdit">
						<!-- <td> -->
                        <a href="#" @click="editModal(detailbarangmasuk)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                       |
                        <a href="#" @click="deleteData(detailbarangmasuk.id)">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                   
                    <tr>
                        <td colspan="6" style="font-weight:bold; text-align:center;">Grand Total</td>                      
                        <td style="font-weight:bold; text-align:right;">{{returnRupiahBulat(grandtotal)}}</td>
                        <!--<td v-if="get_selisih >= 0 && tingkat != '2'"></td>-->
                        <td v-if="canEdit"></td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                <div class="row">                  
                        <div class="col-12">
                            <pagination :records="parseInt(detailbarangmasuks.total)" v-model="page" :per-page="perPage" :options="{texts: { count: 'Menampilkan data ke {from} sampai {to} dari total {count} data|{count} records|One record' }}" @paginate="getResults"></pagination>
                        </div>
                  </div>
                  <div class="row">
                        <div class="col-12">
                                Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Data
                        </div>
                    </div>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document" style="max-width:1024px;">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Detail Barang Masuk</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Detail Barang Masuk</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateDetailBarangMasuk() : createDetailBarangMasuk()">
                    
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nama Barang</label>
                            <v-select :options="barangs" :reduce="(barang) => barang.id"
                                        label="nama_barang"
                                        v-model="form.barang_id"
                            >								
								<template #option="{ nama_barang, keterangan, nama_kategori_barang, nama_satuan }">
                                    <div style="width:100%; background-color:#CCCCCC; padding-left:2px; border:1px solid #000;"><span style="border-bottom:1px solid #FFF; font-weight:bold;">{{ nama_kategori_barang }} </span></br>- {{ nama_barang }} ({{ nama_satuan }}) : {{ keterangan }}</div>
                                </template>
								
                            </v-select>
                            <has-error :form="form" field="barang_id"></has-error>
                        </div>
                        <!--<div class="form-group">
                            <label>Kategori Barang</label>
                            <v-select :options="kategoris" :reduce="(kategori) => kategori.id"
                                        label="Nama"
                                        v-model="form.kategori_barang_id"
                            ></v-select>
                            <has-error :form="form" field="kategori_barang_id"></has-error>
                        </div>-->
                        <div class="form-group">
                            <label>Qty</label>
                            <input style="text-align:right;" @change="getTotalHarga" v-model="form.qty" type="number" id="qty" name="qty"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Qty') }">
                            <has-error :form="form" field="qty"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Harga Satuan</label>
                            <input style="text-align:right;" @keyup="returnAngkaFloat" @change="getTotalHarga" v-model="form.harga" type="text" id="harga" name="harga"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Harga') }">
                            <has-error :form="form" field="harga"></has-error>
                        </div>

                        <div class="form-group">
                            <label>Total Harga</label>
                            <input style="text-align:right; font-weight:bold;" id="total_harga" type="text" name="total_harga" value="0" class="form-control" readonly>
                        </div>
                    </div>

                     <input type="hidden" v-model="form.barang_masuk_id" name="barang_masuk_id">

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Pagination from 'vue-pagination-2';

 var get_barang_masuk_id = "";
 var get_selisih = "";
 var totalHarga = 0;
var tingkat = 0;

    export default {
        components: {
            Pagination,
            Datepicker
        },
        data () {
            return {
                editmode: false,
                searchTerm:'',
                detailbarangmasuks : {},
                barangs : [],
                kategoris : [],
                grandtotal:0,
                form: new Form({
                    id : '',
                    barang_masuk_id: '',
                    barang_id: '',
                    kategori_barang_id: '',
                    nama_barang:'',
                    qty:'',
                    nama_satuan:'',
                    harga:'',
                }),
                sortIndex: 'id',
                sortDirection: 'desc',
                perPage:10,
                showTable:'detail_barang_masuk',
                page: 1,
				tahunBarangMasuk: null,
				is_saldo_awal: 0,
				canEdit: false,
            }
        },
        methods: {
			evaluateAccess() {
			  /*this.canEdit =
				this.is_saldo_awal == 1 &&
				this.get_selisih > 0 &&
				this.tingkat != '2';*/
				
				const belumTerkunci = this.get_selisih >= 0;
				  const selainPuskesmas = this.tingkat != '2';
				  const puskesmasSaldoAwal = this.tingkat == '2' && this.is_saldo_awal == 1;

				  this.canEdit = belumTerkunci && (selainPuskesmas || puskesmasSaldoAwal);
			},

			loadBarangMasukMeta() {
				/*axios
				  .get('/api/barang_masuk/' + this.get_barang_masuk_id + '/meta')
				  .then(({ data }) => {
					  this.get_selisih = data.data.status_kunci;
					  this.tingkat = data.data.tingkat;
				  })
				  .catch(() => {
					  this.get_selisih = -1;
					  this.tingkat = '2';
				  });*/
				  
				  axios
					.get('/api/barang_masuk/' + this.get_barang_masuk_id + '/meta')
					.then(({ data }) => {

					  this.get_selisih = data.data.status_kunci;
					  this.tingkat = data.data.tingkat;
					  this.is_saldo_awal = data.data.is_saldo_awal;

					  this.evaluateAccess();

					})
					.catch(() => {
					  this.canEdit = false;
					});
			},

           returnAngkaFloat(e) {
                if (!/^[0-9\.]+$/.test(e.target.value)) {
                        if(e.target.value.substring(e.target.value.length-1) == ','){
                            e.target.value = e.target.value.substring(0,e.target.value.length-1) + ".";
                        }else{
                            e.target.value = e.target.value.substring(0,e.target.value.length-1);
                        }
                }
            },

			returnRupiahAsli(val){
				if (val === null || val === undefined || val === '') return '0,00';

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(val);
			},

			/*
			returnRupiahBulat(val){
				if (val === null || val === undefined || val === '') return '0,00';

				let angka = parseFloat(val);
				let decimal = angka - Math.floor(angka);

				if (decimal >= 0.5) {
					angka = Math.ceil(angka);
				} else {
					angka = Math.floor(angka);
				}

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(angka);
			},
			*/
			
			/*
			returnRupiahBulat(val){
				 let angka = parseFloat(val);

				let decimal = Math.round(
					(angka - Math.floor(angka)) * 100
				) / 100;

				angka = decimal > 0.50
					? Math.ceil(angka)
					: Math.floor(angka);

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(angka);
			},
			*/
			
			returnRupiahBulat(val){
				return Number(val).toLocaleString('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			},
			
            returnRupiah(val){				
				if (val === null || val === undefined || val === '') return '0,00';

				let angka = parseFloat(val);
				let decimal = angka - Math.floor(angka);

				if (decimal >= 0.5) {
					angka = Math.ceil(angka); // bulatkan ke atas
				}

				return new Intl.NumberFormat('id-ID', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(angka);
            },

            getTotalHarga(){
                var txtQty = 0;
                var txtHargaSatuan = 0;

                txtQty = parseFloat($("#qty").val());
                txtHargaSatuan = parseFloat($("#harga").val());

                if(txtQty > 0 && txtHargaSatuan > 0){
                    totalHarga  = txtQty * txtHargaSatuan;
                }else{
                    totalHarga = 0;
                }

                $("#total_harga").val(this.returnRupiah(totalHarga));
            },

            sortRecords (index, tableName) {
               
                /*this.sortIndex = index;
                this.showTable = tableName;
                if(this.sortDirection == 'asc'){
                   this.sortDirection = 'desc';
                }else if(this.sortDirection == 'desc'){
                   this.sortDirection = 'asc';
                }else{
                   this.sortDirection = 'asc';
                }                
                this.$Progress.start();                
                this.page = 1;
                axios.get('/api/detail_barang_masuk?barang_masuk_id='+this.get_barang_masuk_id+'&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.detailbarangmasuks = data.data.detail_barang_masuk, this.grandtotal = data.data.grand_total));
                this.$Progress.finish();*/
				
				this.sortIndex = index
				  this.showTable = tableName

				  this.sortDirection =
					this.sortDirection === 'asc' ? 'desc' : 'asc'

				  this.page = 1
				  this.getResults(1)
            },    
            changePageRange(){
			/*
                this.$Progress.start();
                  this.page = 1;
                    axios.get('/api/detail_barang_masuk?barang_masuk_id='+this.get_barang_masuk_id+'&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.detailbarangmasuks = data.data.detail_barang_masuk, this.grandtotal = data.data.grand_total));
                  this.$Progress.finish();*/
				  
				this.page = 1
				this.getResults(1)  
            },

            getResults(page = 1) {
                  this.$Progress.start();
				  
				  let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                  
                  axios.get('/api/detail_barang_masuk?barang_masuk_id='
						+this.get_barang_masuk_id
						+'&page=' + page
						+ '&search=' + param
						+'&sortIndex=' + this.sortIndex 
						+ '&sortDirection=' + this.sortDirection 
						+ '&showPage=' + this.perPage 
						+ '&showTable=' + this.showTable)
					.then(({ data }) => (this.detailbarangmasuks = data.data.detail_barang_masuk, this.grandtotal = data.data.grand_total));

                  this.$Progress.finish();
            },
            updateDetailBarangMasuk(){
                this.$Progress.start();
                this.form.put('/api/detail_barang_masuk/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadDetailBarangMasuks();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },

            deleteData(id){
              Swal.fire({
                  title: 'Apa anda yakin?',
                  text: "Setelah terhapus data tidak bisa dikembalikan!",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Ya'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                            this.form.delete('/api/detail_barang_masuk/'+id)
                            .then((response)=>{
                                
                                Toast.fire({
                                        icon: 'success',
                                        title: response.data.message
                                });

                                this.$Progress.finish();

                                //setTimeout(function(){this.loadDetailBarangMasuks();},10);

                            })
                            .catch(()=>{
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Some error occured! Please try again'
                                });
                            })

                            window.location.reload();
                        }
                  })
             },

            editModal(detail_barang_masuk){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(detail_barang_masuk);

                 $("#total_harga").val(this.returnRupiah(parseFloat(this.form.qty) * parseFloat(this.form.harga)));
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                this.form.barang_masuk_id = this.get_barang_masuk_id;
                $('#addNew').modal('show');

                $("#total_harga").val('0');
            },
            loadKategoris(){
                axios.get("/api/kategori_barang/objlist").then(({ data }) => (this.kategoris = data.data));
            },
            loadBarangs(){
                let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                axios.get("/api/barang/objlist").then(({ data }) => (this.barangs = data.data));
            },

            loadDetailBarangMasuks(){
                /*this.$Progress.start();
                let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;

                    axios.get("/api/detail_barang_masuk?search=" + param + "&barang_masuk_id="+this.get_barang_masuk_id+'&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.detailbarangmasuks = data.data.detail_barang_masuk, this.grandtotal = data.data.grand_total));

                 this.$Progress.finish();   */
				 
				this.page = 1
				this.getResults(1)
            },
            
            createDetailBarangMasuk(){

                this.form.post('/api/detail_barang_masuk')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadDetailBarangMasuks();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            }

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            let urlParams = new URLSearchParams(window.location.search);
           
            //this.get_barang_masuk_id =  window.location.href.split('=').pop();
            this.get_barang_masuk_id =  urlParams.get('barang_masuk_id');
            //this.get_selisih =  urlParams.get('status_kunci');
			//this.tingkat =  urlParams.get('tingkat');

            this.$Progress.start();
			
			this.loadBarangMasukMeta();
            this.loadDetailBarangMasuks();
            this.loadBarangs();
            //this.loadKategoris();
            this.$Progress.finish();
			
			this.tahunBarangMasuk = this.$route.query.tahun
				  ? parseInt(this.$route.query.tahun)
				  : new Date().getFullYear()
        },
        watch: {
            searchTerm: function() {
                this.loadDetailBarangMasuks();
            }
        }
    }

/*
    function returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split(','),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            }
*/
            function angkaFloat(e) {
                if (!/^[0-9\.]+$/.test(e.value)) {
                        if(e.value.substring(e.value.length-1) == ','){
                            e.value = e.value.substring(0,e.value.length-1) + ".";
                        }else{
                            e.value = e.value.substring(0,e.value.length-1);
                        }
                }
            }
</script>